import { render, staticRenderFns } from "./PaymentTransactions.vue?vue&type=template&id=2e7886b7&"
import script from "./PaymentTransactions.vue?vue&type=script&lang=js&"
export * from "./PaymentTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports